/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-console */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import React, { useState, memo, useContext } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";

import { ITEM_ID_DIVISION, TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../../Constants";

import { useScreenSize } from "../../../component/Theme";
import SompoSearchMode, { SompoSearchModeValue } from "../../../component/mode/SompoSearchMode";
import SompoTextField from "../../../component/textField/SompoTextField";
import SompoDatePickers, { SompoDatePicker } from "../../../component/datePicker/SompoDatePickers";
import { LocationState, SearchCondition, SearchFilter } from "../TrainingList";
import SompoLoading from "../../../component/loading/SompoLoading";

import { shapingString } from "../../../logic/utility/textUtil";
import SompoContext from "../../../logic/context/SompoContext";
import { DateFormats, dateToStringDate, parseJSDate } from "../../../logic/datetime";
import { CATEGORY_ID_ALL, CATEGORY_ID_CAREERS, CATEGORY_ID_CURRICULUMS, Category as CategoryDatum } from "../../../logic/hook/useCategories";
import { ItemsItem, SearchCareerClassListPayload } from "../../../logic/api/SearchCareerClassListService";

interface SearchAreaProps {
    locationState: LocationState;
    search: (condition: SearchCareerClassListPayload) => void;
    requiredDivisions: ItemsItem[];
    searchMode: SompoSearchModeValue;
    setSearchMode: React.Dispatch<React.SetStateAction<SompoSearchModeValue>>;
    handleSearchModeChanged: (selected: SompoSearchModeValue) => void;
    showCurriculumsFn: () => boolean;
    getLevelCategoriesFn: (parentId: string) => CategoryDatum[] | undefined;
}

/**
 * フィルタリングコンポーネント
 */
interface SearchConditionsItemList {
    id: string;
    name: string;
}
interface SearchConditionsList {
    searchType: string;
    categoryName: string;
    items: SearchConditionsItemList[];
}

interface TypeListProps {
    searchType: string;
    items: SearchConditionsItemList[] | CategoryDatum[];
}

// 検索条件
const TYPE = "type";
const FREEWORD = "freeword";
const MAIN_CATEGORY = "mainCategory";
const SUB_CATEGORY = "subCategory";
const TRAINING_TYPE = "trainingType";
const REQUIRED = "required";

// カテゴリの初期設定値
const DEFAULT_CATEGORY_CHECK_CATEGORY = `1_${CATEGORY_ID_ALL}`;

const OPTIONS_TRAINING_TYPE = [
    {
        id: "02",
        name: "集合研修",
    },
    {
        id: "03",
        name: "eラーニング",
    },
];

const OPTIONS_REQUIRED = [
    {
        id: "02",
        name: "必須のみを表示",
    },
];

const getRootCategory = (searchMode?: SompoSearchModeValue) => {
    switch (searchMode) {
        case TRAINING_TYPE_CURRICULUM:
            return CATEGORY_ID_CURRICULUMS;
        case TRAINING_TYPE_CAREER:
        default:
            return CATEGORY_ID_CAREERS;
    }
};

/**
 * 検索条件エリア
 * @returns
 */
const SearchArea = (props: SearchAreaProps) => {
    // Props.
    const { locationState, search, requiredDivisions, searchMode, setSearchMode, handleSearchModeChanged, showCurriculumsFn, getLevelCategoriesFn } =
        props;

    // Hooks.
    const sompoContext = React.useContext(SompoContext);
    const theme = useTheme();
    const { desktop } = useScreenSize();

    // States.
    const [searchFilter, setSearchFilter] = useState<SearchFilter>({
        [TYPE]: TRAINING_TYPE_CAREER,
        [MAIN_CATEGORY]: CATEGORY_ID_ALL,
        [SUB_CATEGORY]: DEFAULT_CATEGORY_CHECK_CATEGORY,
        [TRAINING_TYPE]: CATEGORY_ID_ALL,
        [REQUIRED]: CATEGORY_ID_ALL,
    });
    const [searchConditions, setSearchConditions] = useState<SearchCondition>({
        freeword: sompoContext.searchText,
        startDate: "",
        endDate: "",
        elearning: true,
        shugo: true,
        categoryId: "",
        detail: [],
        careerType: TRAINING_TYPE_CAREER,
    });
    const [searchAreaOpen, setSearchAreaOpen] = useState(false);
    const [selectCategories, setSelectCategories] = useState<string[]>([getRootCategory(), DEFAULT_CATEGORY_CHECK_CATEGORY]); // 初期値として親（#0）と「すべて」を入れる

    // Logics.
    function isCategory(category: any): category is CategoryDatum {
        return category.level !== undefined;
    }

    // 検索対象
    const _handleSearchModeChanged = (selected: SompoSearchModeValue) => {
        setSearchMode(selected);
        setSelectCategories([getRootCategory(selected), DEFAULT_CATEGORY_CHECK_CATEGORY]);
        handleSearchModeChanged(selected);
    };

    React.useEffect(() => {
        const {
            parentCategoryId: parentCategoryIdState = "",
            categoryId: categoryIdState = "",
            searchMode: searchModeState = TRAINING_TYPE_CAREER,
        } = locationState || {};
        const _freeword = sompoContext.searchText || "";

        // 検索対象
        setSearchMode(searchModeState);

        // 表示フィルター（カテゴリ）
        if (categoryIdState && parentCategoryIdState) {
            // 3階層目まで対応できるよう3階層目の全てを入れる
            // 検索時にはすべてより1階層上のアイテムで検索できるようになっているため、childrenの有無に関わらず入れて問題ない
            setSelectCategories([getRootCategory(searchModeState), parentCategoryIdState, categoryIdState, `3_${CATEGORY_ID_ALL}`]);
        }

        // 検索条件（入力内容）
        setSearchFilter({ ...searchFilter, [SUB_CATEGORY]: categoryIdState, [FREEWORD]: _freeword, [TYPE]: searchModeState });
        const _setSearchConditions = {
            ...searchConditions,
            freeword: _freeword,
            categoryId: categoryIdState,
            careerType: searchModeState,
        };

        // 検索条件
        setSearchConditions(_setSearchConditions);
        const _searchCategoryId = {
            ..._setSearchConditions,
            categoryId: categoryIdState || "",
        };

        // 検索
        search(_searchCategoryId);
    }, [locationState]);

    /**
     * 検索ボタン押下時の処理
     */
    const handleClickSearch = () => {
        const reverseSelectCategories = [...selectCategories].reverse();
        const parentCategoriesId = reverseSelectCategories.find((item) => !item.endsWith(CATEGORY_ID_ALL));
        const searchCategoryId = parentCategoriesId === CATEGORY_ID_CAREERS || parentCategoriesId === undefined ? "" : parentCategoriesId;
        const _searchConditions = searchConditions;
        const requiredCondition = [
            {
                type: ITEM_ID_DIVISION,
                items: requiredDivisions,
            },
        ];
        _searchConditions.categoryId = searchCategoryId;
        _searchConditions.elearning = searchFilter[TRAINING_TYPE] !== "02";
        _searchConditions.shugo = searchFilter[TRAINING_TYPE] !== "03";
        _searchConditions.detail = searchFilter[REQUIRED] === "02" ? requiredCondition : [];
        _searchConditions.careerType = searchMode;
        setSearchConditions(_searchConditions);
        search(_searchConditions);
    };
    /**
     * フォーム入力時のイベント処理
     * @param event
     */
    const handleChangeForm = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchConditions({ ...searchConditions, [event.target.name]: event.target.value });
    };

    /**
     * 日付け入力（選択）時のイベント処理
     * @param name
     * @param date
     */
    const handleDateChange = (name: string, date: Date | null) => {
        if (!date) {
            setSearchConditions({ ...searchConditions, [name]: null });
            return;
        }
        if (Number.isNaN(date.getDate())) return;
        const dateText = dateToStringDate(date);
        setSearchConditions({ ...searchConditions, [name]: dateText });
    };

    /**
     * ボタン作成DOM
     * @param props
     * @returns
     */
    const TypeList = (listProps: TypeListProps) => {
        const { items, searchType } = listProps;
        const categoryData = {
            isCategory: isCategory(items[0]),
            level: isCategory(items[0]) ? items[0].level : undefined,
        };
        const labelStyle = (checked: boolean) => {
            let _style = {
                justifyContent: "center",
                display: "flex",
                padding: 0,
                mr: 0.5,
                mb: 0.5,
                color: "#3B434C",
                backgroundColor: "white",
                borderRadius: "0.3em",
            };
            if (checked) {
                _style = {
                    ..._style,
                    color: "#FFFFFF",
                    backgroundColor: "#666666",
                };
            }
            return _style;
        };

        /**
         * ボタンを選択したときのイベント処理
         * @param event
         * @returns
         */
        const handleClick = (id: string) => {
            setSearchFilter({
                ...searchFilter,
                [searchType]: id,
            });
            if (categoryData.isCategory) {
                const categoriesId = selectCategories.splice(0, Number(categoryData.level));
                let value;
                if (value === CATEGORY_ID_ALL) {
                    value = `${categoryData.level}_${CATEGORY_ID_ALL}`;
                } else {
                    value = id;
                }
                categoriesId.push(value);
                categoriesId.push(`${Number(categoryData.level) + 1}_${CATEGORY_ID_ALL}`);
                setSelectCategories(categoriesId);
            }
        };

        const categoryIdAll = categoryData.isCategory ? `${categoryData.level}_${CATEGORY_ID_ALL}` : CATEGORY_ID_ALL;
        const checkAll = categoryData.isCategory ? selectCategories.includes(categoryIdAll) : searchFilter[searchType] === categoryIdAll;

        return (
            <Grid container direction="row" sx={{ ml: 1 }}>
                <Grid item>
                    <Button size="small" sx={labelStyle(checkAll)} onClick={() => handleClick(categoryIdAll)}>
                        <Typography sx={{ mx: 2 }}>{"すべて"}</Typography>
                    </Button>
                </Grid>
                <Grid item xs container direction="row" justifyContent="flex-start" alignItems="flex-start">
                    {items.map((item, categoryIndex) => {
                        const checked = categoryData.isCategory ? selectCategories.includes(item.id) : searchFilter[searchType] === item.id;
                        return (
                            <Button size="small" sx={labelStyle(checked)} key={categoryIndex} onClick={() => handleClick(item.id)}>
                                <Typography sx={{ mx: 2 }}>{shapingString(item.name, 10)}</Typography>
                            </Button>
                        );
                    })}
                </Grid>
            </Grid>
        );
    };

    /**
     * カテゴリ選択DOM
     * @param props
     * @returns
     */
    const SelectCategories = (categoriesProps: { parentId: string; index: number }) => {
        const { parentId, index } = categoriesProps;
        const targetCategories = getLevelCategoriesFn(parentId) || [];
        if (!targetCategories.length) return <></>;
        return (
            <>
                {targetCategories.length && (
                    <Grid item xs={12} sm={12} md={12} container direction="column" spacing={2} key={`${SUB_CATEGORY}_${parentId}_${index}`}>
                        {parentId === CATEGORY_ID_CAREERS || parentId === CATEGORY_ID_CURRICULUMS ? (
                            <>
                                <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"カテゴリ"}</Typography>
                                <TypeList items={targetCategories} searchType={SUB_CATEGORY} />
                            </>
                        ) : (
                            <Grid sx={{ ml: 1 }}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    {"サブカテゴリ"}
                                </Typography>
                                <TypeList items={targetCategories} searchType={SUB_CATEGORY} />
                            </Grid>
                        )}
                    </Grid>
                )}
            </>
        );
    };

    // Render component.
    const startDate = !searchConditions.startDate ? undefined : parseJSDate(searchConditions.startDate, DateFormats.YYYYMMDD);
    const endDate = !searchConditions.endDate ? undefined : parseJSDate(searchConditions.endDate, DateFormats.YYYYMMDD);
    const showCurriculums = showCurriculumsFn();
    const searchCurriculum = showCurriculums && searchMode === TRAINING_TYPE_CURRICULUM;
    // console.log("SearchArea", {
    //     searchMode,
    //     selectCategories,
    //     showCurriculums,
    //     locationState,
    // });
    return (
        <>
            {/** 絞り込みボタン モバイルのみ表示 */}
            <Grid
                sx={{ mb: 1, display: { xs: "flex", sm: "flex", md: "none" }, pointerEvents: sompoContext.loading ? "none" : "auto" }}
                container
                direction={"row"}
                alignItems={"flex-start"}
            >
                <Button
                    size="small"
                    variant="text"
                    onClick={() => {
                        setSearchAreaOpen(!searchAreaOpen);
                    }}
                    sx={{
                        bgcolor: "white",
                        color: theme.palette.primary.contrastText,
                        pl: 2,
                        pr: 2,
                        borderRadius: "1rem",
                    }}
                >
                    <SortIcon />
                    <Typography>絞り込み</Typography>
                </Button>
            </Grid>
            {/** 検索条件エリア */}
            <Box
                sx={{
                    backgroundColor: "#EADADC",
                    borderRadius: "30px",
                    display: {
                        xs: searchAreaOpen ? "flex" : "none",
                        sm: searchAreaOpen ? "flex" : "none",
                        md: "flex",
                        pointerEvents: sompoContext.loading ? "none" : "auto",
                    },
                }}
            >
                <Grid container direction="column" spacing={3} sx={{ pt: 5, pb: 3, px: 5 }}>
                    <Grid item container direction="row" spacing={3}>
                        <Grid container direction="row" alignItems="center">
                            {showCurriculums && (
                                <Grid item container direction="column" xs={12} sx={{ pl: 1 }}>
                                    <Grid item>
                                        <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"検索対象"}</Typography>
                                    </Grid>
                                    <Grid item sx={{ ml: 1, mb: 1 }}>
                                        <SompoSearchMode searchMode={searchMode} onChangeSelected={_handleSearchModeChanged} radioProps={{ py: 0 }} />
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={12} md={6} container direction="column" sx={{ pl: 1 }}>
                                <Grid item>
                                    <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"キーワード"}</Typography>
                                </Grid>
                                <Grid item sx={{ ml: 1 }}>
                                    <SompoTextField
                                        size="small"
                                        variant="outlined"
                                        label={
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <SearchIcon sx={{ fontSize: "1.2rem" }} />
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        color: "#7C8188",
                                                    }}
                                                >
                                                    研修・講座を検索
                                                </Typography>
                                            </Box>
                                        }
                                        sx={{
                                            width: desktop ? "70%" : "90%",
                                            borderRadius: "10px",
                                            backgroundColor: "#F5F6F6",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderRadius: "10px",
                                            },
                                        }}
                                        name={FREEWORD}
                                        value={searchConditions[FREEWORD]}
                                        onChange={handleChangeForm}
                                    />
                                </Grid>
                            </Grid>
                            {!searchCurriculum && (
                                <Grid item xs={12} sm={12} md={6} container direction="column" sx={{ pl: 1 }}>
                                    <Grid item>
                                        <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"対象開催期間"}</Typography>
                                    </Grid>
                                    <Grid item sx={{ ml: 1 }}>
                                        <SompoDatePickers>
                                            <Grid
                                                container
                                                flexWrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                spacing={1}
                                            >
                                                <Grid item>
                                                    <SompoDatePicker
                                                        label="開始"
                                                        name="startDate"
                                                        value={startDate}
                                                        onChange={(date) => {
                                                            handleDateChange("startDate", date);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item>~</Grid>
                                                <Grid item>
                                                    <SompoDatePicker
                                                        label="終了"
                                                        name="endDate"
                                                        value={endDate}
                                                        onChange={(date) => {
                                                            handleDateChange("endDate", date);
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SompoDatePickers>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                        {selectCategories.map((item, index) => (
                            <SelectCategories parentId={item} index={index} key={`${item}_${index}`} />
                        ))}

                        {!searchCurriculum && (
                            <Grid item xs={12} sm={12} md={6} container direction="column" spacing={2}>
                                <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"講座タイプ"}</Typography>
                                <TypeList items={OPTIONS_TRAINING_TYPE} searchType={TRAINING_TYPE} />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={12} md={6} container direction="column" spacing={2}>
                            <Typography sx={{ fontWeight: "bold", mb: 1 }}>{"必須条件"}</Typography>
                            <TypeList items={OPTIONS_REQUIRED} searchType={REQUIRED} />
                        </Grid>
                    </Grid>
                    <Grid item sx={{ display: "flex", mx: "auto" }}>
                        <Button
                            size="medium"
                            variant="text"
                            sx={{
                                bgcolor: "#f4f4f4",
                                transition: "all 0.2s ease-in-out",
                                width: "150px",
                                border: `2px solid ${theme.palette.primary.main}`,
                            }}
                            onClick={handleClickSearch}
                        >
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                                検索
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default SearchArea;
